import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} storeVisitors
 * @returns {Workbook}
 */
export const exportExcel = async (
  storeVisitors,
  selectedStore,
  startDate,
  endDate
) => {
  const json = excelHelper.jsonToJson(
    [storeVisitors],
    [
      {
        name: "VENTAS PROMEDIO",
        props: [
          {
            inValue: "name",
            outValue: "SEDE",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD DE VENTAS",
          },
          {
            inValue: "average_ticket",
            outValue: "VENTA PROMEDIO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;

  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        "reporte-ventas-promedio-general_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        "reporte-ventas-promedio_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardAverageTicket/excel.js